'use strict';

var _regeneratorRuntime = require("/mnt/e/carperto/haendler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBaseUrl = exports.async = exports.UPLOAD = exports.DELETE = exports.PUT = exports.POST = exports.GET_BODY = exports.GET = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _promise = require('promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

try {
  require('babel-polyfill');
} catch (e) {// console.info('Babel polyfill could not be loaded...', e);
}

var baseUrl = null;

var myFetch = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var withContentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var response, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (defaultBody && options.body && typeof options.body !== 'string') {
              options.body = JSON.stringify(options.body);
            }

            options = _extends({}, options, {
              mode: 'cors',
              headers: _extends({
                'Accept': 'application/json'
              }, options.headers),
              credentials: 'include',
              cache: 'default'
            });

            if (withContentType) {
              options.headers['Content-Type'] = 'application/json';
            }

            _context.next = 5;
            return fetch((baseUrl || '') + url, options);

          case 5:
            response = _context.sent;

            if (!(response.status === 204)) {
              _context.next = 10;
              break;
            }

            _context.t0 = {};
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return response.json();

          case 12:
            _context.t0 = _context.sent;

          case 13:
            json = _context.t0;

            if (!(!response.ok || json.error)) {
              _context.next = 16;
              break;
            }

            throw {
              message: json.error || response.statusText,
              error: json.error || response.statusText,
              code: json.code || response.status,
              params: json.params || null,
              error_code: json.error_code || null,
              feedback: json.allow_feedback !== undefined ? json.allow_feedback : true
            };

          case 16:
            return _context.abrupt('return', json);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function myFetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var GET = myFetch;

var GET_BODY = function GET_BODY(url, data, options) {
  return myFetch(url, _extends({}, options, {
    body: data
  }));
};

var POST = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, data, options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _extends({}, options, {
              method: 'POST',
              body: data
            });
            _context2.next = 3;
            return myFetch(url, options);

          case 3:
            return _context2.abrupt('return', _context2.sent);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function POST(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var PUT = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, data, options) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _extends({}, options, {
              method: 'PUT',
              body: data
            });
            _context3.next = 3;
            return myFetch(url, options);

          case 3:
            return _context3.abrupt('return', _context3.sent);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function PUT(_x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var DELETE = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, data, options) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _extends({}, options, {
              method: 'DELETE'
            });

            if (data) {
              options.body = data;
            }

            _context4.next = 4;
            return myFetch(url, options);

          case 4:
            return _context4.abrupt('return', _context4.sent);

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function DELETE(_x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();

var UPLOAD = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, data, options) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return myFetch(url, _extends({}, options, {
              method: 'POST',
              body: data
            }), false, false);

          case 2:
            return _context5.abrupt('return', _context5.sent);

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function UPLOAD(_x14, _x15, _x16) {
    return _ref5.apply(this, arguments);
  };
}();

var async = function async() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new _promise2.default(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, duration);
  });
};

var setBaseUrl = function setBaseUrl(url) {
  return baseUrl = url;
};

exports.GET = GET;
exports.GET_BODY = GET_BODY;
exports.POST = POST;
exports.PUT = PUT;
exports.DELETE = DELETE;
exports.UPLOAD = UPLOAD;
exports.async = async;
exports.setBaseUrl = setBaseUrl;
exports.default = myFetch;